import React from 'react';
import asyncComponent from 'util/asyncComponent';
import { PermissionRoute } from './common/PermissionRoute';

const InformationRoutes = ({ match }) =>
  <>
    <PermissionRoute path={`${match.url}/user-manual`} exact component={(asyncComponent(() => import('../pages/information/UserManual')))}/>
    <PermissionRoute path={`${match.url}/terms`} exact component={(asyncComponent(() => import('../pages/information/Terms')))}/>
    <PermissionRoute path={`${match.url}/policy`} exact component={(asyncComponent(() => import('../pages/information/Privacy')))}/>
    <PermissionRoute path={`${match.url}/release-notes`} exact component={(asyncComponent(() => import('../pages/information/ReleaseNotes')))}/>
  </>;

export { InformationRoutes };
